import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Popover,
  Avatar,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import NotePadrao from "../NotePadrao/NotePadrao";
import getCookie from "../../../hooks/getCookie";
import { getAvatarUrl } from "../../../utils/getAvatarUrl";

function CardListPadrao({ isDarkMode, openModal, closeModal, showArquivados }) {
  const [showAddActions, setShowAddActions] = React.useState(false);
  const [alert2, setAlert2] = React.useState(null);
  const list = [""];
  const username = getCookie("username");
  const sessionId = getCookie("session_id");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const colorPalette = [
    "#164b35",
    "#533f04",
    "#702e00",
    "#5d1f1a",
    "#352c63",
    "#09326c",
    "#164555",
    "#37471f",
    "#50253f",
    "#596773",
  ];

  return (
    <>
      <Box
        style={{
          display: "flex",
          maxHeight: "100%",
        }}
        className="lista-usuario"
      >
        <Box
          className="column-container arquivado-tour"
          sx={{
            display: showArquivados ? "block" : "none",
            backgroundColor: `${list.background_color} !important`,
            minWidth: "250px",
          }}
        >
          {/* Header da lista */}
          <div
            style={{
              display: "flex",
              width: "90%",
              alignItems: "center",
              marginBottom: "10px",
              borderBottom: "2px solid #cebcbc2c",
              paddingBottom: "5px",
            }}
          >
            <div style={{ flex: 1, textAlign: "center" }}>
              <Typography variant="h7" className="title-list">
                {"Arquivados"}
              </Typography>
            </div>
          </div>

          {/* Conteúdo da lista */}
          <Box className="column">
            <NotePadrao isDarkMode={isDarkMode} />
            <div
              style={{
                padding: "10px",
                borderRadius: "10px",
                backgroundColor: "#424141",
              }}
            >
              <Typography variant="h7" className="title-list">
                {"Título do Card arquivado"}
              </Typography>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Avatar
                  src={getAvatarUrl("lesteboard")}
                  sx={{ width: 24, height: 24, ml: -1 }}
                  title="Lesteboard"
                />
              </div>
            </div>
          </Box>
        </Box>
        <Box
          className="column-container"
          sx={{
            backgroundColor: `${list.background_color} !important`,
            minWidth: "250px",
          }}
        >
          {/* Header da lista */}
          <div
            style={{
              display: "flex",
              width: "90%",
              alignItems: "center",
              marginBottom: "10px",
              borderBottom: "2px solid #cebcbc2c",
              paddingBottom: "5px",
            }}
          >
            <div style={{ flex: 1, textAlign: "center" }}>
              <Typography variant="h7" className="title-list">
                {"Titulo da coluna"}
              </Typography>
            </div>

            {list.list_name !== "Arquivado" && (
              <MoreVertIcon className="icon-dots" />
            )}
          </div>

          {/* Conteúdo da lista */}
          <Box className="column">
            <div className="note-padrao-tour">
            <NotePadrao isDarkMode={isDarkMode} />
            </div>

            <button
              className="card-padrao-tour"
              onClick={() => openModal()}
              style={{
                cursor: "pointer",
                width: "100%",
                border: "none",
                color: "#fff",
                backgroundColor: isDarkMode ? "#424141" : "#009373",
                borderRadius: "10px",
                padding: "10px",
                textAlign: "left",
              }}
            >
              <Typography variant="h6" className="title-list">
                {"Titulo do Card"}
              </Typography>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Avatar
                  src={getAvatarUrl("lesteboard")}
                  sx={{ width: 24, height: 24, ml: -1 }}
                  title="Lesteboard"
                />
              </div>
            </button>
          </Box>

          {/* Adicionar novo card/nota */}
          <div className="column-add">
            <div className="add-card-container">
              {!showAddActions ? (
                <Button
                  className="button-add-card"
                  startIcon={<AddIcon />}
                  onClick={() => setShowAddActions(true)}
                  style={{
                    borderRadius: "5px",
                    padding: "5px 10px",
                    fontWeight: "bold",
                    transition: "background-color 0.3s, color 0.3s",
                    width: "100%",
                    textTransform: "uppercase",
                    marginTop: "auto",
                  }}
                >
                  Adicionar
                </Button>
              ) : (
                <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                  <Button
                    className="button-add-cartao"
                    variant="contained"
                    color="inherit"
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      textTransform: "capitalize",
                    }}
                  >
                    Cartão
                  </Button>
                  <Button
                    className="button-add-cartao"
                    variant="contained"
                    color="inherit"
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      textTransform: "capitalize",
                    }}
                  >
                    Nota
                  </Button>
                  <Button
                    className="button-add-cartao"
                    variant="contained"
                    color="inherit"
                    sx={{
                      minWidth: 0,
                      px: 1,
                      textTransform: "none",
                    }}
                    onClick={() => setShowAddActions(false)}
                    title="Cancelar"
                  >
                    ✕
                  </Button>
                </Box>
              )}
            </div>
          </div>
        </Box>
        <Box
          className="column-container collapsed"
          sx={{
            backgroundColor: "#ccc",
            width: "60px",
            minWidth: "60px",
            height: "150px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 5px",
            borderRadius: "5px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            borderBottom: "2px solid rgba(206, 188, 188, 0.5)", // <--- borda visível
          }}
        >
          <Typography
            variant="h7"
            className="title-list"
            style={{
              writingMode: "vertical-rl",
              textOrientation: "mixed",
              fontSize: "12px",
              textAlign: "center",
              marginBottom: "10px",
              paddingBottom: "5px",
              borderBottom: "2px solid #cebcbc",
            }}
          >
            {"TESTE 2"}
          </Typography>
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
              marginBottom: "10px",
              cursor: "pointer",
            }}
          >
            {0}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default CardListPadrao;
